import { Fragment, useState } from "react";
import { Grid, Typography } from "@mui/material";
import { capitalCase, sentenceCase } from "change-case-all";

import { Paper } from "../../../components";
import ShowAudienceSizeDialog from "./ShowAudienceSize";
import { ActiveTextEighteen, colors } from "../../css components/Style";
import MissedParameters from "./campaign form components/MissedParameters";

export default function AdminCampaignStatus({
  audienceSize,
  formikProps,
  isDisabled,
  channelSectionRef,
  scrollToChannelSection,
  setForceClick,
  component = "",
}) {
  const [showAudSize, setShowAudSize] = useState();
  const [dialogState, setDialogState] = useState({ data: {}, state: false });

  return (
    <Fragment>
      {!!formikProps.values.campaignID && (
        <Paper>
          {!!(audienceSize?.audience_params || audienceSize?.audience_size) &&
            formikProps.values.permissionSettings?.consumer_audience_view && (
              <Grid size={12} textAlign={"center"} display={"flex"}>
                <ActiveTextEighteen style={{ color: colors.green }}>
                  {formikProps.values.status === "ACTIVE"
                    ? "Audience Size "
                    : "Your audience size is ready! "}
                </ActiveTextEighteen>
                <ActiveTextEighteen
                  color={colors.purple}
                  style={{ cursor: "pointer" }}
                  onClick={() => setShowAudSize(true)}
                >
                  &nbsp; View
                </ActiveTextEighteen>
              </Grid>
            )}

          {formikProps.values.campaignStatus === "REQUESTED" &&
            formikProps.values?.isPendingSizing &&
            !(audienceSize?.audience_params || audienceSize?.audience_size) && (
              <Grid size={12} textAlign={"center"} display={"flex"}>
                <ActiveTextEighteen style={{ color: colors.warning }}>
                  Your campaign request has been raised and is expected to be
                  ready within 24 to 72 hours.
                </ActiveTextEighteen>
              </Grid>
            )}

          {formikProps.values.campaignStatus === "REQUESTED" &&
            !formikProps.values?.isSizingSetOnTime &&
            !(audienceSize?.audience_params || audienceSize?.audience_size) && (
              <Grid size={12} textAlign={"center"} display={"flex"}>
                <ActiveTextEighteen style={{ color: colors.warning }}>
                  The process is taking longer than expected. Please contact the
                  admin.
                </ActiveTextEighteen>
              </Grid>
            )}

          <Grid size={12}>
            <Typography variant="h5" style={{ color: colorPicker() }}>
              {capitalCase(formikProps.values?.newCampaignStatus)}
              {formikProps.values.campaignID &&
                formikProps.values?.newCampaignStatus === "PARTIAL_ACCEPTED" &&
                formikProps.values?.missedParameter?.length > 0 && (
                  <Typography color={colors.error}>
                    <Typography
                      onClick={handleMissedParam}
                      variant="button"
                      style={{ cursor: "pointer", color: colors.info }}
                    >
                      CLICK
                    </Typography>{" "}
                    to view the current status of the requested attributes.{" "}
                  </Typography>
                )}
            </Typography>
          </Grid>

          {component === "" &&
            isDisabled === false &&
            Boolean(formikProps.values?.adminCampaignStatus) &&
            formikProps.values?.campaignLaunched &&
            !formikProps.values.campaignInitiated && (
              <Typography style={{ fontSize: "14px" }}>
                Please fill channel details to launch campaign.
              </Typography>
            )}

          {formikProps.values.message && (
            <Grid size={12}>
              <Typography variant="h5" style={{ color: colorPicker() }}>
                {sentenceCase(formikProps.values.message)}{" "}
              </Typography>
            </Grid>
          )}
        </Paper>
      )}

      <ShowAudienceSizeDialog
        formikProps={formikProps}
        audienceSize={audienceSize}
        showAudSize={showAudSize}
        setShowAudSize={setShowAudSize}
        isDisabled={isDisabled}
        channelSectionRef={channelSectionRef}
        setForceClick={setForceClick}
        scrollToChannelSection={scrollToChannelSection}
      />

      <MissedParameters
        formikProps={formikProps}
        dialogState={dialogState}
        setDialogState={setDialogState}
      />
    </Fragment>
  );

  function handleMissedParam() {
    setDialogState({
      state: true,
      data: formikProps.values,
      component: "params",
    });
  }

  function colorPicker() {
    let color;

    if (
      formikProps.values.campaignStatus === "REQUESTED" ||
      formikProps.values.campaignStatus === "LIVE_REQUESTED" ||
      formikProps.values.campaignStatus === "CREATED"
    ) {
      color = colors.warning;
    }

    if (formikProps.values.campaignStatus === "OFFER_ACCEPTED") {
      color = colors.success;
    }

    if (
      formikProps.values.campaignStatus === "INITIATED" ||
      formikProps.values.campaignStatus === "SIZE_READY"
    ) {
      color = colors.purple;
    }

    if (
      formikProps.values.campaignStatuss === "REJECTED" ||
      formikProps.values.campaignStatus === "Expired" ||
      formikProps.values.campaignStatus === "FAILED"
    ) {
      color = colors.error;
    }

    if (
      formikProps.values.campaignStatus === "READY" ||
      formikProps.values.campaignStatus === "ACTIVE"
    ) {
      color = colors.success;
    }

    return color;
  }
}
